import {AxiosRequestConfig} from 'axios';
import request from '../axios';
import {RemoveEmptyFiledFromObject} from '../../utilities/helper/removeEmptyFiledFromObject';

export const getStoreInfo = async (storeId: string) => {
  const {data}: {data: IStoreInfo} = await request.get(
    `/api/v2/store/store-info?guid=` + storeId,
  );
  return data;
};

// TODO: check
export const getNewestStoreList = async (
  ctx: IGetPostsPayload,
  pageNumber: number,
  app: string,
) => {
  RemoveEmptyFiledFromObject(ctx);

  const {data}: {data: INewEstData} = await request.get(
    `/api/v2/store/newest-stores?app=${app}&page=` + pageNumber,
    {
      params: {
        ...ctx,
      },
    } as AxiosRequestConfig,
  );
  return data;
};
